<template>
  <v-flex xs12 sm12 class="primary--text event-line">
    <v-layout>
      <v-flex>
        <v-avatar size="30">
          <slot name="headerIcon">
            <v-icon size="20">{{mainIcon}}</v-icon>
          </slot>
        </v-avatar>
        <span class="ml-2 font-weight-bold">{{event.userDisplayName}}</span>
        <span class="font-weight-light">&nbsp;[{{userCompanyName}}]&nbsp;<slot></slot>
          <template v-if="showUserAgent">
          using {{event.chatAgent}}
          </template>
        </span>
      </v-flex>
      <v-flex class="pr-2">
        <v-tooltip v-model="showVersion" v-if="showUserAgent" left>
          <template slot="activator" slot-scope="{ on }">
            <v-img class="agent-img pt-1"
                   width="50"
                   @click="showVersion = !showVersion"
                   :src="agentIcon"/>
          </template>
          <span>{{event.chatAgentPlatform}} v{{event.chatAgentVersion}}</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'ChatUserHeader',
  props: {
    event: {
      required: true,
      type: Object,
    },
    participants: {
      required: true,
      type: Array,
    },
    mainIcon: {
      type: String,
    },
    companyName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showVersion: false,
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    showUserAgent() {
      return _.includes(['PhoneIOS', 'PhoneAndroid', 'TabletIOS', 'TabletAndroid'], this.event.chatAgentPlatform);
    },
    agentIcon() {
      return this.event.chatAgentPlatform.indexOf('IOS') > -1 ? '/static/LTN_and_Apple.png' : '/static/LTN_and_Android.png';
    },
    participant() {
      return this.participants.find(p => p.userId === this.event.userId);
    },
    userCompanyName() {
      return this.companyName ? this.companyName : _.get(this.participant, 'organizationName');
    },
  },
};
</script>
<style lang="css">
  .agent-img {
    float: right;
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/timeline/ChatUserHeader.vue